import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./scss/styles.scss";
import * as dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import isoWeek from "dayjs/plugin/isoWeek";
import isToday from "dayjs/plugin/isToday";
import duration from "dayjs/plugin/duration";
import weekDay from "dayjs/plugin/weekday";
import weekOfYear from "dayjs/plugin/weekOfYear";
import en from "dayjs/locale/en";

dayjs.extend(utc);
dayjs.extend(isoWeek);
dayjs.extend(isToday);
dayjs.extend(duration);
dayjs.extend(weekOfYear);
dayjs.extend(weekDay);
dayjs.locale({
  ...en,
  weekStart: 1,
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
